export interface ApiEnvelope<T> {
  code: number | string;
  data?: T;
  message?: string;
}

export type ApiErrorKind = 'network' | 'api' | 'locations' | 'invalid-response' | 'empty';

export class ApiClientError extends Error {
  constructor(public kind: ApiErrorKind, message: string) {
    super(message);
    this.name = 'ApiClientError';
  }
}



// WEBPACK FOOTER //
// ./src/models/api/api-envelope.ts